/**
 * Derive form_submissions.reference_* from the form_assignment relationship row
 * returned by /api/relationships/user/:userId/forms (parent_table, parent_id, user_groups_periods_id).
 */
export function resolveSubmissionReferenceFromFormRelationship(form, userId, existingSubmission = null) {
  if (existingSubmission?.reference_table && existingSubmission?.reference_id) {
    return {
      reference_table: existingSubmission.reference_table,
      reference_id: String(existingSubmission.reference_id)
    };
  }

  if (!form?.parent_table) {
    return { reference_table: null, reference_id: null };
  }

  const parentTable = form.parent_table;
  const parentId = form.parent_id;
  const ugpId = form.user_groups_periods_id;

  switch (parentTable) {
    case 'users':
      return userId
        ? { reference_table: 'users', reference_id: String(userId) }
        : { reference_table: null, reference_id: null };
    case 'user_groups_periods':
      return parentId || ugpId
        ? {
            reference_table: 'user_groups_periods',
            reference_id: String(parentId || ugpId)
          }
        : { reference_table: null, reference_id: null };
    case 'groups_periods':
      return ugpId
        ? { reference_table: 'user_groups_periods', reference_id: String(ugpId) }
        : { reference_table: null, reference_id: null };
    default:
      return { reference_table: null, reference_id: null };
  }
}
